import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function AppContainer({ children }: Props) {
  const styles: CSSProperties = {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    minHeight: "100dvh",
  };

  return (
    <div id="app-container" style={styles}>
      {children}
    </div>
  );
}
